import React from 'react';

interface StarRatingProps {
  stars: number;
  maxStars?: number;
}

const StarRating: React.FC<StarRatingProps> = ({ stars, maxStars = 5 }) => {
  const starStyle = { display: 'inline-block', width: '1.1em', textAlign: 'center' as const,  };
  const starsElements = [];

  for (let i = 0; i < maxStars; i++) {
    if (i < stars) {
      starsElements.push(<span key={i} className="text-warning" style={{...starStyle, fontSize: '0.9em'}}>⭐</span>);
    } else {
      starsElements.push(<span key={i} className="text-secondary" style={{...starStyle, fontSize: '1rem'}}>☆</span>);
    }
  }

  return (
    <div className="d-inline-flex align-items-center gap-1">
      {starsElements}
    </div>
  );
};

export default StarRating;
